import React from 'react';

const PageNotFound = () => {
  return (
    <>
      <p>Личный кабинет</p>
      <h1>404. Page not found</h1>
    </>
  );
};

export default PageNotFound;
